import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Siren, Phone, ExternalLink } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { useEmergencies } from "../../lib/emergencies";
import { ProtocolList } from "./ProtocolList";

export function EmergencySheet() {
  const data = useEmergencies();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState("");
  useEffect(() => {
    const h = (e) => { setOpen(e.detail || ""); setShow(true); };
    window.addEventListener("open-emergency", h);
    return () => window.removeEventListener("open-emergency", h);
  }, []);
  useEffect(() => {
    if (show && open) setTimeout(() => document.getElementById(`emergency-${open}`)?.scrollIntoView({ block: "start", behavior: "smooth" }), 250);
  }, [show, open]);
  return (
    <>
      <button type="button" onClick={() => { setOpen(""); setShow(true); }} data-testid="emergency-fab"
        className="fixed z-50 bottom-5 right-5 flex items-center gap-2 rounded-full bg-red-600 hover:bg-red-700 text-white font-bold pl-4 pr-5 h-12 shadow-lg shadow-red-600/30 transition-transform active:scale-95">
        <span className="relative flex"><span className="absolute inset-0 rounded-full bg-white/40 animate-ping" /><Siren className="relative w-5 h-5" /></span> Emergency
      </button>
      <Sheet open={show} onOpenChange={setShow}>
        <SheetContent side="right" className="w-full sm:max-w-xl overflow-y-auto bg-red-50" data-testid="emergency-sheet">
          <SheetHeader className="text-left">
            <SheetTitle className="font-heading text-xl text-red-700 flex items-center gap-2"><Siren className="w-5 h-5" /> Medical emergency protocols</SheetTitle>
            <SheetDescription className="text-slate-700">
              <span className="flex items-center gap-1.5 font-semibold text-slate-900"><Phone className="w-4 h-4 text-red-600" /> Call for help first — local emergency number (997 / 911 Saudi Arabia · 999 UK · 112 EU · 911 USA)</span>
              <span className="block mt-1 text-xs">Resuscitation Council UK · ERC 2025 · AHA 2025 · BNF. Follow your training and local protocols.</span>
            </SheetDescription>
          </SheetHeader>
          <div className="mt-4">{data ? <ProtocolList protocols={data.protocols} open={open} onOpen={setOpen} /> : <p className="text-sm text-slate-500">Loading…</p>}</div>
          <Link to="/app/emergency" onClick={() => setShow(false)} data-testid="emergency-sheet-full-page" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-red-700"><ExternalLink className="w-4 h-4" /> Open the full emergency page</Link>
        </SheetContent>
      </Sheet>
    </>
  );
}
